import React, { useState, useEffect } from "react";
import axios from "axios";

const calculateProgress = (data) => {
  if (!data || Object.keys(data).length === 0) {
    return 0;
  }

  let totalFields = 0;
  let filledFields = 0;

  const countFields = (obj) => {
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (typeof value === "object" && value !== null) {
          countFields(value);
        } else if (value !== null && value !== undefined && value !== "") {
          filledFields++;
        }
        totalFields++;
      }
    }
  };

  countFields(data);

  return ((filledFields / totalFields) * 100).toFixed(0);
};

const ClinicalDataStatus = ({ record }) => {
  const donor_id = record?.id;
  const [donorClinicals, setDonorClinicals] = useState([]);

  // Fetch recipient clinical data
  const getRecpientClinicalDataFromServer = async () => {
    try {
      let userToken = localStorage.getItem("token");
      let urlLink = `${process.env.REACT_APP_API_URL}/clinical/donor/${donor_id}`;
      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await axios(config);
      setDonorClinicals(response.data);
    } catch (err) {
      console.log("error api call ", err?.response?.data || err.message);
    }
  };

  useEffect(() => {
    getRecpientClinicalDataFromServer();
  }, [donor_id]);

  const progress = calculateProgress(donorClinicals);

  return (
    <div className="flex flex-col w-full mt-3">
      <div className="ml-0 text-sm">
        {/* {record?.name} */}
        {record?.donor_active_status ? (
          <span className="flex flex-row items-center">
            {" "}
            <div
              style={{
                backgroundColor: "green",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
              }}
            ></div>
            &nbsp;
            {record.name}
          </span>
        ) : (
          <span className="flex flex-row items-center">
            <div
              style={{
                backgroundColor: "red",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
              }}
            ></div>
            &nbsp;
            {record.name}
          </span>
        )}
      </div>
      <div className="flex items-center -mt-5">
        <i
          className="flex-shrink-0 mdi mdi-plus-circle"
          style={{
            color: "red",
            marginRight: "0px",
            display: "flex",
            alignItems: "center",
            fontSize: "11px",
          }}
        ></i>
        <div className="flex items-center w-full h-2 bg-gray-200 rounded-full">
          <div
            className="h-full transition-all duration-300 ease-in-out bg-green-500 rounded-full"
            style={{ width: `${progress}%` }}
          />
        </div>
        <span className="ml-1 text-xs">{`${progress}%`}</span>
      </div>
    </div>
  );
};

export default ClinicalDataStatus;
